<script>

export default {
    data() {
        const sortStack = []

        const headers = this.makeHeadersWithIds()
        if (headers.length == 0) {
            return {
                sortStack: []
            }
        }

        const defaultSortStack = this.getDefaultSortStack()
        if (defaultSortStack && defaultSortStack.length > 0) {
            return {
                sortStack: defaultSortStack
            }
        }

        headers.forEach(h => {
            if (h.defaultSort) {
                sortStack.push({
                    id: h.id,
                    isDesc: !!h.defaultSortIsDesc,
                })
            }
        })

        if (!sortStack.length) {
            sortStack.push({
                id: headers[0].id,
                isDesc: false,
            })
        }

        return {
            sortStack: sortStack,
        }
    },
    computed: {
        sortColumnId() {
            if (this.hasFixedSortOrder) {return null}

            if (this.sortStack.length) {
                return this.sortStack[0].id
            }

            return null
        },
        sortIsAsc() {
            if (this.sortStack.length) {
                return !this.sortStack[0].isDesc
            }

            return true
        },
    },
    methods: {
        sortRows(rows) {
            if (this.hasFixedSortOrder) {return rows}
            const headers = this.makeHeadersWithIds()

            // identify any numeric columns
            const numericCols = new Set()
            headers.forEach(h => {
                if (h.sortDataType && h.sortDataType == 'numeric') {
                    numericCols.add(h.id)
                }
            })

            // Resolve each sort column's cell index / direction / numeric-ness once
            // up front. Previously this was an indexOf + includes on every comparison,
            // and the comparator runs O(n log n) times over the whole table.
            const sortKeys = this.sortStack.map(sortColumn => ({
                idx: this.headerOrderIds.indexOf(sortColumn.id),
                orderMultiplier: sortColumn.isDesc ? -1 : 1,
                isNumeric: numericCols.has(sortColumn.id),
            }))

            rows.sort((a, b) => {
                for (const key of sortKeys) {
                    const idx = key.idx
                    let valA = ((a.cells[idx] && a.cells[idx].value) ? a.cells[idx].value : a.cells[idx]) || ''
                    let valB = ((b.cells[idx] && b.cells[idx].value) ? b.cells[idx].value : b.cells[idx]) || ''

                    if (key.isNumeric) {
                        valA = valA ? parseFloat(valA) : 0
                        valB = valB ? parseFloat(valB) : 0
                    }

                    if (valA != valB) {
                        return valA > valB ? key.orderMultiplier : -1 * key.orderMultiplier
                    }
                }

                return 0
            })

            return rows
        },
        onSort(orderColumnId) {
            if (this.sortStack.length && this.sortStack[0].id == orderColumnId) {
                // The user clicked on the order column that's already at the top of the sort stack. Just reverse it.
                this.sortStack[0].isDesc = !this.sortStack[0].isDesc
                return
            }

            // Move the new column to the top of the stack
            const tmpStack = this.sortStack.filter(c => (c.id != orderColumnId))
            this.sortStack.splice(0, this.sortStack.length)  // empty the stack in a way that Vue would be able to observe
            this.sortStack.push({id: orderColumnId, isDesc: false})
            tmpStack.forEach(s => this.sortStack.push(s))
        },
    },
}
</script>
